import React from "react";
// styled components
import { Modal, Button} from "antd";
// models
interface IProps {
  nombre: string;
  modal: boolean;
  eliminar: any;
  cancelar: any;
  indexDocumentacion: number;
}

export const ModalEliminarDocumentosTecnicos: React.FC<IProps> = (
  props: IProps
) => {
  return (
    <Modal
      className="modal-eliminar-class ant-modal-close-x2"
      visible={props.modal}
      onOk={() => props.eliminar(props.indexDocumentacion)}
      onCancel={props.cancelar}
      width={662}
      footer={[
        <Button key="b_cancelar_modal_docu_tec2" className="button-gray-ghost" onClick={props.cancelar}>
          Cancelar
        </Button>,
        <Button key="b_aceptar_modal_docu_tec2" className="button-azul-radius" onClick={props.eliminar}>
          Aceptar
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(162, 103, 95,0.85)",
      }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 font-size-24px font-color-AD0808 font-family-Montserrat-SemiBold justify-content-center">
            Eliminar documento técnico
          </div>
          <div className="text-center col-12 font-family-Montserrat-Regular font-size-14px justify-content-center font-color-000000 mt-2">
            Estás a punto de eliminar "{props.nombre}"
          </div>
          <div className="text-center col-12 font-family-Montserrat-bold font-size-14px justify-content-center mt-1 font-color-000000">
            ¿Deseas eliminarlo?
          </div>
        </div>
      </div>
    </Modal>
  );
};
